import AuthApiService from '@package/core/src/auth/AuthApiService';
import AuthInteractor from '@package/core/src/auth/AuthInteractor';
import config from 'config-base';

import { apiClient } from '../services';
import { useQueryClient, useStrictMutation, useStrictQuery } from '../useCustomQuery';
import useExternalRedirect from '../useExternalRedirect';

import { AUTH_USER_QUERY_DATA_KEY } from './types';

const authService = new AuthApiService(apiClient);
const authInteractor = new AuthInteractor(authService);

export default function useAuth() {
  const queryClient = useQueryClient();
  const { redirect } = useExternalRedirect();

  const { data: user, isLoading: userLoading } = useStrictQuery(
    [AUTH_USER_QUERY_DATA_KEY],
    async () => {
      const res = await authInteractor.getUser();

      return res.data;
    },
    { refetchOnMount: false },
  );

  const { mutate: logout } = useStrictMutation(
    async () => {
      await authInteractor.logout();
      redirect(config.mainPyramydairUrl);
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([AUTH_USER_QUERY_DATA_KEY]);
      },
    },
  );

  return { user, userLoading, logout };
}
